exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wrapper{position:relative}.itemscount{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:20px;height:20px;position:absolute;top:-50%;right:-50%;background:#ef4c31;border:1px solid #fff;border-radius:100%;font-size:9px;color:#fff}.fa-th{font-size:24px}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/services/services.component.css"],"names":[],"mappings":"AAAA,SACE,iBAAmB,CACpB,YAGC,oBAAA,oBAAA,aAAc,wBACd,qBAAA,uBAAwB,yBACxB,sBAAA,mBAAoB,WACR,YACC,kBACM,SACT,WACE,mBACQ,sBACI,mBACJ,cACL,UACH,CACb,OAGC,cAAgB,CACjB","file":"services.component.css","sourcesContent":[".wrapper{\n  position: relative;\n}\n\n.itemscount {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  background: #ef4c31;\n  border: 1px solid white;\n  border-radius: 100%;\n  font-size: 9px;\n  color: #fff;\n}\n\n.fa-th{\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/services/services.component.css
// module id = BrFT
// module chunks = 6